import React, { Fragment } from "react";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import { NavLink } from "react-router-dom";
import "./steps.css";

const FinishCheck = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title pt-120 md:pt-30 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap pt-3 pb-5">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-12 text-center">
                  <div className="page-title-box">
                    <h2 className="title">Onboarding</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section sofax-section-padding2  pt-65 pb-130">
          <div className="container" bis_skin_checked={1}>
            <div className="row clearfix" bis_skin_checked={1}>
              <div
                className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center"
                bis_skin_checked={1}
              >
                <div className=" px-0 pb-0 mb-3" bis_skin_checked={1}>
                  <h2 className="mb-3" id="heading">
                    KYC Documents Upload
                  </h2>
                  <div className="row justify-content-center">
                    <div className="col-md-10 text-center"> 
                       <p className="mb-3 fs-5">
                        On our mobile app to complete your onboarding process we
                        require your Photo ID and a selfie. We use ID Scan
                        solution which takes less than a minute to complete this
                        for you.{" "}
                      </p>
                    </div>
                    </div>
                    
                   
                  {/*<div class="row justify-content-center">
                          <div class="col-4">

                              <button type="button" class="btn btn-primary video-btn2" data-bs-toggle="modal" data-src="https://www.youtube.com/embed/qceO0YPfcVo" data-bs-target="#myModal">
                                  <i class="fa fa-play"></i> Watch Explainer Video
                              </button>
                          </div>
                      </div>*/}
                  <div id="msform" bis_skin_checked={1}>
                    {/* progressbar */}
                    <ul id="progressbar">
                      <NavLink to="/kycupload" bis_skin_checked={1}>
                        <li className="active" id="confirm">
                          <strong>1) Scanning Your Id</strong>
                        </li>
                      </NavLink>
                      <NavLink to="/livenesscheck" bis_skin_checked={1}>
                        <li id="confirm" className="active">
                          <strong>2) Liveness Check</strong>
                        </li>
                      </NavLink>
                      <NavLink to="/finishcheck" bis_skin_checked={1}>
                        <li id="confirm" className="active">
                          <strong>Finish</strong>
                        </li>
                      </NavLink>
                    </ul>
                    {/* fieldsets */}
                    <fieldset>
                      <div className="form-card" bis_skin_checked={1}>
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="https://skyipay.co.uk/assets/images/photo/finishimg.png"
                                alt="Finish Image"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  On completion of your IDScan and Liveness
                                  check you will get a success screen to confirm
                                  completion of onboarding.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <div
                            className="col-12 text-center"
                            bis_skin_checked={1}
                          >
                            <h5 className="purple-text text-center">
                              If you have any further questions then please
                              visit our Onboarding FAQs page.
                            </h5>
                          </div>
                          <NavLink
                            to="/onboardingFAQ"
                            className="mt-5 sofax-default-btn pill sofax-header-btn text-whitee"
                            style={{
                              background: "#041b5f",
                              color: "white",
                              fontWeight: "bold",
                              height: "40px",
                              width: "200px",
                              fontSize: "24px",
                              padding: "8px",
                              borderRadius: "20px",
                            }}
                            bis_skin_checked={1}
                          >
                            FAQs
                          </NavLink>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default FinishCheck;
